export default __webpack_public_path__ + "static/media/o-boticario-logo.df991d00.svg";